import { useEffect } from "react";
import type { ReactNode } from "react";
import { Icon } from "./Icon";

/* Panneau latéral : la fiche d'un enregistrement, ou son formulaire d'édition
   quand l'écran est trop étroit pour éditer dans le tableau. */

export function Drawer({
  titre, sous, onClose, pied, large, children,
}: {
  titre: string;
  sous?: ReactNode;
  onClose: () => void;
  pied?: ReactNode;
  /** Un catalogue a besoin de colonnes : le panneau s'élargit sur grand écran. */
  large?: boolean;
  children: ReactNode;
}) {
  useEffect(() => {
    const esc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onClose]);

  return (
    <>
      <button className="scrim" aria-label="Fermer le panneau" onClick={onClose} />
      <aside className={large ? "drawer drawer-lg" : "drawer"} role="dialog" aria-modal="true" aria-label={titre}>
        <header className="drawer-h">
          <div className="drawer-t-wrap">
            <h2 className="drawer-t">{titre}</h2>
            {sous != null ? <div className="drawer-s">{sous}</div> : null}
          </div>
          <button className="icon-btn" aria-label="Fermer" onClick={onClose}>
            <Icon n="fermer" cls="" />
          </button>
        </header>
        <div className="drawer-b">{children}</div>
        {pied != null ? <footer className="drawer-f">{pied}</footer> : null}
      </aside>
    </>
  );
}

/** Un champ de formulaire étiqueté. */
export function Champ({
  id, label, children,
}: { id: string; label: string; children: ReactNode }) {
  return (
    <div className="champ">
      <label htmlFor={id}>{label}</label>
      {children}
    </div>
  );
}
